import { BaseWidget, Condition } from '@draftkings/widgets-core';
import { SportSliderWidgetConfig, ISportSlider, IState, ConditionKeys } from '../contracts';
import { SherpaRetriver } from '../retriever';
import { LeagueNavRequestResolver, SportEvent, League, Sport } from '@draftkings/dk-data-layer';
import { Parser } from '../parser';
import { State } from '../state';
import { App } from '../components/App/App';
import { getDefaultValue, getLocalizedUrl } from '@draftkings/sportsbook-common-utils';
import { getWebHeaders } from '../utils';
import { dict } from '../dict';

export class SportSlider extends BaseWidget implements ISportSlider {
    private dataProvider: IState;
    constructor(domId: string, options: SportSliderWidgetConfig) {
        super(domId, (err) => console.error(err));
        const condition = new Condition(ConditionKeys);
        const locale = options.locale ?? 'en';
        const localizationFlags = options.localizationFlags ?? { enabled: false, useLocale: false };
        const dictionary = { ...dict, ...(options.dictionary || {}) };
        const retriever = new SherpaRetriver({
            leagueNavRequestResolver: new LeagueNavRequestResolver({
                baseUrl: getLocalizedUrl(options.productConfig.navigationBff, locale, localizationFlags.useLocale),
                requestTimeout: getDefaultValue(options.requestTimeout, 120000),
                consumerMetadata: getWebHeaders(options.consumerVersion)
            }),
            SportsbookLeague: options.dkDataLayer.SportsbookLeague,
            leagueId: options.fetchId,
            condition,
            defaultData: {
                events: new Map<string, SportEvent>(),
                leagues: new Map<string, League>(),
                sports: new Map<string, Sport>()
            },
            consumerVersion: options.consumerVersion,
            productConfig: options.productConfig,
            logError: options.logError,
            trackEvent: options.trackEvent
        });
        const parser = new Parser({
            retriever,
            logos: options.logos,
            productConfig: options.productConfig,
            id: options.currentId,
            excludeId: options.currentId,
            staticS3Host: options.staticS3Host,
            swooshBaseUrl: options.swooshBaseUrl,
            isSwooshTeamLogosEnabledForSportSlider: options.isSwooshTeamLogosEnabledForSportSlider,
            locale,
            useLocale: localizationFlags.useLocale,
            trackEvent: options.trackEvent
        });

        this.dataProvider = new State({
            parser,
            messageBus: options.messageBus,
            condition
        });

        this.component = (
            <App
                dataProvider={this.dataProvider}
                renderLoader={options.renderLoader}
                dictionary={dictionary}
                locale={locale}
                localizationFlags={localizationFlags}
            />
        );
    }

    activate() {
        super.activate();
        this.dataProvider.activate();
        return this;
    }

    deactivate() {
        super.deactivate();
        this.dataProvider.deactivate();
        return this;
    }
}
